// import PropTypes from 'prop-types';
// import { useContext, useEffect, useState } from 'react';
// import useFetch from 'hooks/useFetch';

// // COMPONENTS
// import StudentsFormDetails from 'forms/Students/StudentsFormDetails';
// import StudentsFormDetailByTeacher from 'forms/Students/StudentsFormDetailsByTeacher';
// import { toast } from 'react-toastify';

// // CONTEXTS
// import { useLocation } from 'wouter';
// import { TitleContext } from 'contexts/TitleContext';
// import { UserContext } from 'contexts/UserContext';

// // ASSETS
// import { ImArrowLeft2 } from 'react-icons/im';
// import loadingIco from 'components/ui/Logo/loading_azul.gif';

// export default function StudentsViewDetails({ params }) {
//   // Contextos:
//   const { user } = useContext(UserContext);
//   const [, setLocation] = useLocation();
//   const { setTitle } = useContext(TitleContext);

//   // useFetch():
//   const [getApiCallGet, setApiCallGet] = useFetch();
//   const [getApiCallPost, setApiCallPost] = useFetch();
//   const [getApiCallDelete, setApiCallDelete] = useFetch();

//   // Variables:
//   const isNew = params.id === 'new';

//   // Estado para los campos del formulario
//   const [fields, setFields] = useState({
//     // ID_ALUMNES: 0,
//     CODI_BECARI: '',
//     NOM: '',
//     // COGNOM: '',
//     DNI: '',
//     DATA_NAIXAMENT: '',
//     NUM_SS: '',
//     OBSERVACIONS: '',
//     ID_ESCOLA: '',
//     ID_PROFESSOR: '',
//     INICI_PRACTIQUES: '', // Añadir campo para el inicio de prácticas
//     FI_PRACTIQUES: '', // Añadir campo para el fin de prácticas
//     INICI_CHECK: 0,
//     FI_CHECK: 0,
//   });

//    // Estado de carga
//   const [loading, setLoading] = useState(true); // <-- Estado de carga

//   // CRUD: GET
//   useEffect(() => {
//     const titleEdit = {
//       name: `Modificar Alumne`,
//       buttons: [
//         {
//           id: 'btnBack',
//           name: (
//             <span className="flex flex-row items-center w-full">
//               <span className="pl-3 pr-1">
//                 <ImArrowLeft2 size={20} />
//               </span>
//               <span className="pl-1 pr-3">Tornar</span>
//             </span>
//           ),
//           link: `/students/grid`,
//         },
//       ],
//       deleteMTBtn: true,
//       mtId: params.id,
//     };

//     const titleCreate = {
//       name: `Registrar Alumne`,
//       buttons: [
//         {
//           id: 'btnBack',
//           name: (
//             <span className="flex flex-row items-center w-full">
//               <span className="pl-3 pr-1">
//                 <ImArrowLeft2 size={20} />
//               </span>
//               <span className="pl-1 pr-3">Tornar</span>
//             </span>
//           ),
//           link: `/students/grid`,
//         },
//       ],
//     };

//     if (!isNew) {
//       const getApiCall = {
//         url: `students/${params.id}`,
//         method: 'GET',
//         successMessage: null,
//         failureMessage: 'Error de càrrega!',
//       };
//       setApiCallGet(getApiCall);

//       setTitle(titleEdit);
//     } else {
//       setTitle(titleCreate);
//     }
//   }, [params.id, isNew, setApiCallGet, setTitle]);

//   // * Recoger datos API: GET
//   useEffect(() => {
//     if (getApiCallGet.data) {
//       setFields({
//         // ID_ALUMNES: getApiCallGet.data.ID_ALUMNES,
//         CODI_BECARI: getApiCallGet.data.CODI_BECARI,
//         NOM: getApiCallGet.data.NOM,
//         // COGNOM: getApiCallGet.data.COGNOM,
//         DNI: getApiCallGet.data.DNI,
//         DATA_NAIXAMENT: getApiCallGet.data.DATA_NAIXAMENT,
//         NUM_SS: getApiCallGet.data.NUM_SS,
//         OBSERVACIONS: getApiCallGet.data.OBSERVACIONS,
//         ID_ESCOLA: getApiCallGet.data.ID_ESCOLA,
//         ID_PROFESSOR: getApiCallGet.data.ID_PROFESSOR,
//         INICI_PRACTIQUES: getApiCallGet.data.INICI_PRACTIQUES,
//         FI_PRACTIQUES: getApiCallGet.data.FI_PRACTIQUES,
//         INICI_CHECK: getApiCallGet.data.INICI_CHECK,
//         FI_CHECK: getApiCallGet.data.FI_CHECK,
//       });
//       setLoading(false); // <-- Cambia el estado de carga cuando los datos están disponibles
//     }
//   }, [getApiCallGet.data]);

//   // CRUD: POST / PUT
//   const handleSubmit = async (values) => {
//     let url = user.role_id === 1 ? `students/bytchr/${user.id}` : 'students';
//     let method = 'POST';

//     // if (!isNew && user.role_id !== 1) {
//     //   method = 'PUT';
//     //   url += `/${params.id}`;
//     // }
//     if (!isNew && user.role_id !== 1) {
//     method = 'PUT';
//     url += `/${params.id}`;
//   } else if (!isNew && user.role_id === 1) {
//     method = 'PUT';
//     url = `students/bytchr/${params.id}`;
//   }

//     const apiCallPost = {
//       url,
//       method,
//       body: values,
//       messageOk: 'Dades guardades correctament',
//       messageKo: 'Error al guardar les dades',
//       redirectTo: '/students/grid',
//     };
//     await setApiCallPost(apiCallPost);
//   };

// //   const handleSubmit = async (values) => {
// //   let url = 'students'; // URL base
// //   let method = 'POST';  // Método por defecto es POST

// //   // Si no es nuevo y el usuario no es un profesor (rol_id !== 1), usamos PUT para actualizar
// //   if (!isNew && user.role_id !== 1) {
// //     method = 'PUT';
// //     url += `/${params.id}`;
// //   }
// //   // Si no es nuevo y el usuario es profesor (rol_id === 1)
// //   else if (!isNew && user.role_id === 1) {
// //     method = 'PUT';
// //     url = `students/bytchr/${params.id}`;
// //   }

// //   // Aquí es donde añadimos los console.log para depurar
// //   console.log('URL:', url);  // Muestra la URL que se está construyendo
// //   console.log('Method:', method);  // Muestra el método HTTP que se usará (POST o PUT)
// //   console.log('Values:', values);  // Muestra los datos del formulario que se están enviando

// //   // Construimos la llamada API
// //   const apiCallPost = {
// //     url,
// //     method,
// //     body: values,
// //     messageOk: 'Dades guardades correctament',
// //     messageKo: 'Error al guardar les dades',
// //     redirectTo: '/students/grid',
// //   };

// //   // Realizamos la petición
// //   await setApiCallPost(apiCallPost);
// // };


//   // * Mostrar mensaje API: POST / PUT
//   // ! Mostrar error API: POST / PUT
//   useEffect(() => {
//     if (getApiCallPost.isCalled) {
//       const successMessage = (message) =>
//         toast.success(message, {
//           position: toast.POSITION.TOP_CENTER,
//         });

//       const errorMessage = (error) =>
//         toast.error(error, {
//           position: toast.POSITION.TOP_CENTER,
//         });

//       if (getApiCallPost.message) {
//         successMessage(getApiCallPost.message);
//         setLocation(`/students/grid`);
//       }

//       if (getApiCallPost.error) {
//         errorMessage(getApiCallPost.error);
//         setLocation(`/students/grid`);
//       }
//     }
//   }, [getApiCallPost, setLocation]);

//   // CRUD: DELETE
//   const handleDelete = async () => {
//     const apiCallDelete = {
//       url: `students/${params.id}`,
//       method: 'DELETE',
//       messageOk: 'Dades borrades correctament',
//       messageKo: 'Error al borrar les dades',
//       redirectTo: '/students/grid',
//     };
//     await setApiCallDelete(apiCallDelete);
//   };

//   // * Mostrar mensaje API: DELETE
//   // ! Mostrar error API: DELETE
//   useEffect(() => {
//     if (getApiCallDelete.isCalled) {
//       const successMessage = (message) =>
//         toast.success(message, {
//           position: toast.POSITION.TOP_CENTER,
//         });

//       const errorMessage = (error) =>
//         toast.error(error, {
//           position: toast.POSITION.TOP_CENTER,
//         });

//       if (getApiCallDelete.message) {
//         successMessage(getApiCallDelete.message);
//         setLocation(`/students/grid`);
//       }

//       if (getApiCallDelete.error) {
//         errorMessage(getApiCallDelete.error);
//         setLocation(`/students/grid`);
//       }
//     }
//   }, [getApiCallDelete, setLocation]);

//   const renderForm = () => {
//     if (user.role_id === 1) {
//       return (
//         <StudentsFormDetailByTeacher
//           handleSubmit={handleSubmit}
//           handleDelete={handleDelete}
//           fields={fields}
//           isNew={isNew}
//         />
//       );
//     } else {
//       return (
//         <StudentsFormDetails
//           handleSubmit={handleSubmit}
//           handleDelete={handleDelete}
//           fields={fields}
//           isNew={isNew}
//         />
//       );
//     }
//   };

//   return isNew || (!loading && fields.ID_ALUMNES !== 0) ? (
//     renderForm()
//   ) : (
//     <div>
//       <div className="flex items-center content-center justify-center w-full h-full">
//         <p
//           className="flex flex-col-reverse items-center justify-center h-full font-extrabold text-green-700"
//           title="Carregant..."
//         >
//           Carregant!
//           <img src={loadingIco} alt="Loading..." />
//         </p>
//       </div>
//     </div>
//   );
// }

// StudentsViewDetails.propTypes = {
//   params: PropTypes.any,
// };


import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import useFetch from 'hooks/useFetch';

// COMPONENTS
import StudentsFormDetails from 'forms/Students/StudentsFormDetails';
import StudentsFormDetailByTeacher from 'forms/Students/StudentsFormDetailsByTeacher';
import { toast } from 'react-toastify';

// CONTEXTS
import { useLocation } from 'wouter';
import { TitleContext } from 'contexts/TitleContext';
import { UserContext } from 'contexts/UserContext';

// UTILS
import { checkStudentConflict } from 'utils/studentConflicts';

// ASSETS
import { ImArrowLeft2 } from 'react-icons/im';
import loadingIco from 'components/ui/Logo/loading_azul.gif';

export default function StudentsViewDetails({ params }) {
  const { user } = useContext(UserContext);
  const [, setLocation] = useLocation();
  const { setTitle } = useContext(TitleContext);

  const [getApiCallGet, setApiCallGet] = useFetch();
  const [getApiCallPost, setApiCallPost] = useFetch();
  const [getApiCallDelete, setApiCallDelete] = useFetch();
  const [getApiCallStudents, setApiCallStudents] = useFetch(); // ← NUEVO: para cargar alumnos existentes

  const isNew = params.id === 'new';

  const [fields, setFields] = useState({
    CODI_BECARI: '',
    NOM: '',
    DNI: '',
    DATA_NAIXAMENT: '',
    NUM_SS: '',
    OBSERVACIONS: '',
    ID_ESCOLA: '',
    ID_PROFESSOR: '',
    INICI_PRACTIQUES: '',
    FI_PRACTIQUES: '',
    INICI_CHECK: 0,
    FI_CHECK: 0,
  });

  const [loading, setLoading] = useState(true);
  const [existingStudents, setExistingStudents] = useState([]); // ← NUEVO
  const [initialConflict, setInitialConflict] = useState(null);

// Detectar conflictes existents en obrir el formulari (només edició)
useEffect(() => {
  if (isNew) return;
  if (!fields.DNI || !fields.INICI_PRACTIQUES) return;
  if (existingStudents.length === 0) return;

  const conflict = checkStudentConflict({
    dni: user.role_id === 1 ? fields.DNI : fields.DNI, // el camp és el mateix, ve del GET individual
    iniciPractiques: fields.INICI_PRACTIQUES,
    fiPractiques: fields.FI_PRACTIQUES,
    existingStudents,
    dniField: user.role_id === 1 ? 'DNI' : 'DNI_NIE_PASSAPORT',
    excludeId: Number(params.id),
  });

  setInitialConflict(conflict); // null si no hi ha conflicte
}, [isNew, fields.DNI, fields.INICI_PRACTIQUES, fields.FI_PRACTIQUES, existingStudents, user.role_id, params.id]);

  // Cargar alumnos existentes para validar conflictos
  useEffect(() => {
    const apiCall =
      user.role_id === 1
        ? { url: `students/bytchr/${user.id}`, method: 'GET', messageKo: 'Error al carregar alumnes existents' }
        : { url: 'students', method: 'GET', messageKo: 'Error al carregar alumnes existents' };
    setApiCallStudents(apiCall);
  }, [user, setApiCallStudents]);

  useEffect(() => {
    if (getApiCallStudents.data) {
      setExistingStudents(getApiCallStudents.data);
    }
  }, [getApiCallStudents.data]);

  // CRUD: GET (título + carga del alumno si edita)
  useEffect(() => {
    const titleEdit = {
      name: `Modificar Alumne`,
      buttons: [
        {
          id: 'btnBack',
          name: (
            <span className="flex flex-row items-center w-full">
              <span className="pl-3 pr-1">
                <ImArrowLeft2 size={20} />
              </span>
              <span className="pl-1 pr-3">Tornar</span>
            </span>
          ),
          link: `/students/grid`,
        },
      ],
      deleteMTBtn: true,
      mtId: params.id,
    };

    const titleCreate = {
      name: `Registrar Alumne`,
      buttons: [
        {
          id: 'btnBack',
          name: (
            <span className="flex flex-row items-center w-full">
              <span className="pl-3 pr-1">
                <ImArrowLeft2 size={20} />
              </span>
              <span className="pl-1 pr-3">Tornar</span>
            </span>
          ),
          link: `/students/grid`,
        },
      ],
    };

    if (!isNew) {
      setApiCallGet({
        url: `students/${params.id}`,
        method: 'GET',
        successMessage: null,
        failureMessage: 'Error de càrrega!',
      });
      setTitle(titleEdit);
    } else {
      setTitle(titleCreate);
    }
  }, [params.id, isNew, setApiCallGet, setTitle]);

  // Recoger datos alumno (edición)
  useEffect(() => {
    if (getApiCallGet.data) {
      setFields({
        ID_ALUMNES: getApiCallGet.data.ID_ALUMNES, // ← IMPORTANTE para excluirse en la validación
        CODI_BECARI: getApiCallGet.data.CODI_BECARI,
        NOM: getApiCallGet.data.NOM,
        DNI: getApiCallGet.data.DNI,
        DATA_NAIXAMENT: getApiCallGet.data.DATA_NAIXAMENT,
        NUM_SS: getApiCallGet.data.NUM_SS,
        OBSERVACIONS: getApiCallGet.data.OBSERVACIONS,
        ID_ESCOLA: getApiCallGet.data.ID_ESCOLA,
        ID_PROFESSOR: getApiCallGet.data.ID_PROFESSOR,
        INICI_PRACTIQUES: getApiCallGet.data.INICI_PRACTIQUES,
        FI_PRACTIQUES: getApiCallGet.data.FI_PRACTIQUES,
        INICI_CHECK: getApiCallGet.data.INICI_CHECK,
        FI_CHECK: getApiCallGet.data.FI_CHECK,
      });
      setLoading(false);
    }
  }, [getApiCallGet.data]);

  // CRUD: POST / PUT — con validación de conflictos
  const handleSubmit = async (values) => {
    // ==== VALIDACIÓN DE CONFLICTOS ====
    const conflict = checkStudentConflict({
      dni: values.DNI,
      iniciPractiques: values.INICI_PRACTIQUES,
      fiPractiques: values.FI_PRACTIQUES,
      existingStudents,
      dniField: user.role_id === 1 ? 'DNI' : 'DNI_NIE_PASSAPORT',
      excludeId: !isNew ? Number(params.id) : null, // Excluye el propio alumno si es edición
    });

    if (conflict) {
      const err = new Error('STUDENT_CONFLICT');
      err.conflictType = conflict.conflictType;
      err.conflicts = conflict.conflicts;
      throw err; // El formulario lo captura y muestra el banner
    }
    // ==== FIN VALIDACIÓN ====

    let url = user.role_id === 1 ? `students/bytchr/${user.id}` : 'students';
    let method = 'POST';

    if (!isNew && user.role_id !== 1) {
      method = 'PUT';
      url += `/${params.id}`;
    } else if (!isNew && user.role_id === 1) {
      method = 'PUT';
      url = `students/bytchr/${params.id}`;
    }

    const apiCallPost = {
      url,
      method,
      body: values,
      messageOk: 'Dades guardades correctament',
      messageKo: 'Error al guardar les dades',
      redirectTo: '/students/grid',
    };
    await setApiCallPost(apiCallPost);
  };

  // Toast POST/PUT
  useEffect(() => {
    if (getApiCallPost.isCalled) {
      const successMessage = (message) =>
        toast.success(message, { position: toast.POSITION.TOP_CENTER });
      const errorMessage = (error) =>
        toast.error(error, { position: toast.POSITION.TOP_CENTER });

      if (getApiCallPost.message) {
        successMessage(getApiCallPost.message);
        setLocation(`/students/grid`);
      }

      if (getApiCallPost.error) {
        errorMessage(getApiCallPost.error);
        setLocation(`/students/grid`);
      }
    }
  }, [getApiCallPost, setLocation]);

  // CRUD: DELETE
  const handleDelete = async () => {
    const apiCallDelete = {
      url: `students/${params.id}`,
      method: 'DELETE',
      messageOk: 'Dades borrades correctament',
      messageKo: 'Error al borrar les dades',
      redirectTo: '/students/grid',
    };
    await setApiCallDelete(apiCallDelete);
  };

  useEffect(() => {
    if (getApiCallDelete.isCalled) {
      const successMessage = (message) =>
        toast.success(message, { position: toast.POSITION.TOP_CENTER });
      const errorMessage = (error) =>
        toast.error(error, { position: toast.POSITION.TOP_CENTER });

      if (getApiCallDelete.message) {
        successMessage(getApiCallDelete.message);
        setLocation(`/students/grid`);
      }

      if (getApiCallDelete.error) {
        errorMessage(getApiCallDelete.error);
        setLocation(`/students/grid`);
      }
    }
  }, [getApiCallDelete, setLocation]);

  const renderForm = () => {
    if (user.role_id === 1) {
      return (
        <StudentsFormDetailByTeacher
          handleSubmit={handleSubmit}
          handleDelete={handleDelete}
          fields={fields}
          isNew={isNew}
        />
      );
    } else {
      return (
        <StudentsFormDetails
          handleSubmit={handleSubmit}
          handleDelete={handleDelete}
          fields={fields}
          isNew={isNew}
          initialConflict={initialConflict}
        />
      );
    }
  };

  return isNew || (!loading && fields.ID_ALUMNES !== 0) ? (
    renderForm()
  ) : (
    <div>
      <div className="flex items-center content-center justify-center w-full h-full">
        <p
          className="flex flex-col-reverse items-center justify-center h-full font-extrabold text-green-700"
          title="Carregant..."
        >
          Carregant!
          <img src={loadingIco} alt="Loading..." />
        </p>
      </div>
    </div>
  );
}

StudentsViewDetails.propTypes = {
  params: PropTypes.any,
};